var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1823)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.588058 20.0375C0.231853 19.9415 0 19.5878 0 19.0405V0.973127C0 0.466194 0.196313 0.124304 0.507507 0L9.38456 10.0687L0.588058 20.0375ZM1.81005 19.654L12.4952 13.5969L9.89269 10.645L1.81005 19.654ZM12.5688 6.46007L2.03254 0.485998L9.9081 9.47536L12.5688 6.46007ZM13.2837 6.8654L17.4112 9.20572C18.1927 9.64882 18.1998 10.3631 17.4112 10.8102L13.1792 13.2091L10.4189 10.0585L13.2837 6.8654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5084e7561585dc1edc215d6e233f3405.svg";
export { ForwardRef as ReactComponent };